import React, { useState } from "react";
import { FloatButton } from "antd";
import {
    UpOutlined,
    DownOutlined,
    WhatsAppOutlined,
    PhoneOutlined,
    MailOutlined,
    FacebookOutlined,
    TwitterOutlined,
    InstagramOutlined,
    CustomerServiceOutlined,
    LinkedinOutlined,
} from "@ant-design/icons";

const FloatingButtons = () => {
    const [contactsVisible, setContactsVisible] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const scrollToBottom = () => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
    };

    const toggleContacts = () => {
        setContactsVisible(!contactsVisible);
    };

    return (
        <div>
            {/* Floating Buttons for Scrolling */}
            {/* <FloatButton.Group
                trigger="click"
                type="primary"
                style={{ right: 30, bottom: 30 }}
                icon={<UpOutlined />}
            > */}
                <FloatButton
                    icon={<UpOutlined />}
                    onClick={scrollToTop}
                    tooltip="Scroll to Top"
                    style={{ right: 30, bottom: 75 }}

                />
                <FloatButton
                    icon={<DownOutlined />}
                    onClick={scrollToBottom}
                    tooltip="Scroll to Bottom"
                    style={{ right: 30, bottom: 30 }}

                />
            {/* </FloatButton.Group> */}

            {/* Expandable Contact Button */}
            <FloatButton.Group
                trigger="click"
                type="primary"
                style={{ right: 30, bottom: 120}}
                icon={<CustomerServiceOutlined  />}
                onClick={toggleContacts}
            >
                {contactsVisible && (
                    <div className="contact-icons">
                        <FloatButton
                            icon={<WhatsAppOutlined />}
                            tooltip="WhatsApp"
                            href="https://wa.me/+255713697062" // Replace with your WhatsApp link
                            target="_blank"
                        />
                        <FloatButton
                            icon={<PhoneOutlined />}
                            tooltip="Call"
                            href="tel:+255713697062" // Replace with your phone number
                        />
                        <FloatButton
                            icon={<MailOutlined />}
                            tooltip="Email"
                            href="mailto:info@saneckabrand.com" // Replace with your email
                        />
                        <FloatButton
                            icon={<FacebookOutlined />}
                            tooltip="Facebook"
                            href="https://facebook.com/saneckabrand" // Replace with your Facebook link
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                        <FloatButton
                            icon={<TwitterOutlined />}
                            tooltip="X (Twitter)"
                            href="https://x.com/saneckabrand" // Replace with your X (Twitter) handle
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                        <FloatButton
                            icon={<InstagramOutlined />}
                            tooltip="Instagram"
                            href="https://instagram.com/saneckabrand" // Replace with your Instagram profile
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                        <FloatButton
                            icon={<LinkedinOutlined />}
                            tooltip="LinkedIn"
                            href="https://linkedin.com/company/saneckabrand" // Replace with your Instagram profile
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    </div>
                )}
            </FloatButton.Group>
        </div>
    );
};

export default FloatingButtons;
